import { render, staticRenderFns } from "./DialogPageInviteChat.vue?vue&type=template&id=5fac1fca"
import script from "./DialogPageInviteChat.vue?vue&type=script&lang=js"
export * from "./DialogPageInviteChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports